import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import ThemeContext from "./context/ThemeContext";

const container = document.getElementById('root');
const root = createRoot(container);

const app = (
  <Provider store={store}>
    <BrowserRouter basename='/'>
      <ThemeContext>
        <App />
      </ThemeContext>
    </BrowserRouter>
  </Provider>
);

root.render(
  process.env.NODE_ENV === 'development' ? (
    <React.StrictMode>
      {app}
    </React.StrictMode>
  ) : (
    app
  )
);
